// Angular
import { Component, ViewEncapsulation, OnInit, Input, OnChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

// Ngrx
import { Store } from '@ngrx/store';
import { AppState } from '../../store';

// Actions
import * as RememberPassActions from '../../store/access/rememberPass/rememberPass.actions';
import * as RouterActions from '../../store/router/router.actions';

// Helpers
import { Subscriber } from '../../shared/lib/helpers/subscriber';
import { isEmptyObject } from '../../shared/lib/helpers/utils';

import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-rememberpass',
    templateUrl: './rememberPass.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class RememberPassComponent extends Subscriber implements OnInit, OnChanges {
    @Input() bannerPromo;
    @Input() logo;

    bannerPromoImg: SafeUrl = '';
    logoUrl: SafeUrl = '';
    bannerPromoExists = false;

    // Form
    rememberForm: FormGroup;

    // Messages
    isRememberMessageOK: boolean = false;
    rememberMessageKO: string;

    // Flags
    loading: boolean;
    sendIt: boolean;

    constructor(
        private store: Store<AppState>,
        private fb: FormBuilder,
        private translate: TranslateService,
        private sanitize: DomSanitizer
    ) {
        // Call base class constructor
        super();
        this.subscribeRememberPassword();
    }

    subscribeRememberPassword(): void {
        this.addSubscription(
            this.store
                .select((state) => state.rememberPass)
                .subscribe((res) => {
                    if (!isEmptyObject(res.result)) {
                        // Message OK
                        if (res.result[0].code === 0) {
                            this.isRememberMessageOK = true;
                            this.rememberMessageKO = '';
                            this.sendIt = true;
                            // Error
                        } else {
                            this.isRememberMessageOK = false;
                            this.rememberMessageKO = res.result[0].message;
                        }
                    }
                    this.loading = false;
                })
        );
    }

    ngOnInit(): void {
        this.createForm();
    }

    ngOnChanges() {
        // Get background
        if (this.bannerPromo) {
            this.bannerPromoImg = this.sanitize.bypassSecurityTrustUrl(this.bannerPromo);

            // TODO: @test Descomentar para imagen que exista
            // this.bannerPromoImg = this.sanitize.bypassSecurityTrustUrl('https://scontent.fmad3-8.fna.fbcdn.net/v/t1.0-9/42108116_10155831131117525_511068367688302592_n.png?_nc_cat=108&_nc_ht=scontent.fmad3-8.fna&oh=996d7f854efeb14f11c86ff5408adb7a&oe=5C72806D');
            // this.bannerPromo = 'https://scontent.fmad3-8.fna.fbcdn.net/v/t1.0-9/42108116_10155831131117525_511068367688302592_n.png?_nc_cat=108&_nc_ht=scontent.fmad3-8.fna&oh=996d7f854efeb14f11c86ff5408adb7a&oe=5C72806D';

            // TODO: @test Descomentar para imagen que exista desde nuestros assets locales
            // this.bannerPromoImg = 'assets/img/demo-login-banner-finalsss.png';
            // this.bannerPromo = 'assets/img/demo-login-banner-finalsss.png';
        }

        if (this.logo) {
            this.logoUrl = this.sanitize.bypassSecurityTrustUrl(this.logo);
        }
    }

    createForm(): void {
        this.rememberForm = this.fb.group({
            user: ['', Validators.required],
        });
    }

    isFieldUnvalid(field: string): boolean {
        return (
            this.rememberForm.get(field).invalid &&
            (this.rememberForm.get(field).dirty || this.rememberForm.get(field).touched)
        );
    }

    onSubmit(): void {
        this.loading = true;
        if (this.rememberForm.valid) {
            this.rememberPass();
        } else {
            this.loading = false;
        }
    }

    rememberPass(): void {
        const returnPath = window.location.href.replace('/remember', '/reset');
        this.store.dispatch(new RememberPassActions.DoRemember(this.rememberForm.get('user').value, returnPath));
    }

    backToLogin(ev): void {
        ev.preventDefault();

        this.store.dispatch(
            new RouterActions.Go({
                path: ['login'],
            })
        );
    }

    bannerPromoFail() {
        this.bannerPromoExists = false;
    }

    bannerPromoOk() {
        this.bannerPromoExists = true;
    }

    getFormField(field: string) {
        return this.rememberForm.controls[field] as FormArray;
    }
}
